import React from 'react';

import { DEFAULT_STATE, CarouselProvider } from './state';
import Items from './Items';

export interface ContainerProps {
  children: React.ReactElement<any, any> | React.ReactElement<any, any>[];
  className?: string;
  initialActiveItem?: number;
  totalItems?: number;
  $speed?: number;
  announceCurrentItem?: boolean;
}

export const Container = ({
  children,
  initialActiveItem = 0,
  $speed = 500,
  totalItems = 0,
}: ContainerProps): React.ReactElement => {
  React.Children.forEach(children, (child) => {
    if (!totalItems && child?.type.displayName === Items.displayName) {
      totalItems = React.Children.count(child?.props.children);
    }
  });

  const initialState = {
    ...DEFAULT_STATE,
    totalItems: totalItems || DEFAULT_STATE.totalItems,
    currentIndex: initialActiveItem || 0,
    speed: $speed || DEFAULT_STATE.speed,
  };

  if (
    typeof totalItems === 'number' &&
    totalItems > 1 &&
    typeof initialActiveItem === 'number'
  ) {
    initialState.prevIndex =
      initialActiveItem === 0 ? totalItems - 1 : initialActiveItem - 1;
    initialState.nextIndex =
      initialActiveItem === totalItems - 1 ? 0 : initialActiveItem + 1;
  }

  return <CarouselProvider initialState={initialState}>{children}</CarouselProvider>;
};

export default Container;
